module.exports = __webpack_public_path__ + "img/dab_black.f98203c1.jpg";